import {BaseEntity} from "../base.entity";

export enum contactType {
  CUSTOMER = 1,
  CONTRACTOR = 2
}

export interface ContactEntity extends BaseEntity {
  type: contactType;
  company?: string;
  firstName?: string;
  lastName?: string;
  street?: string;
  zip?: string;
  city?: string;
  tel?: string;
  fax?: string;
  mail?: string;
  web?: string;
  logo?: string;
}



// WEBPACK FOOTER //
// ./src/store/contact/contact.entity.ts